export class AutoLayout {
  constructor(difference) {
    this.styleId = 1
    this.width = 400
    this.height = 200
    this.widthType = "px"
    this.heightType = "px"
    this.top = 0
    this.left = 0
    this.opacity = 100
    this.innerElement = "cxAutoLayout"
    this.content = "行布局"
    this.rowColDirection = "vertical"
    this.elementOptions = []
    this.padding = 10 // 内边距
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.margin = 0 // 外边距
    this.marginTop = 0
    this.marginRight = 0
    this.marginLeft = 0
    this.marginBottom = 0
    this.rowColAlignPositionH = "left"
    this.rowColAlignPositionV = "top"
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.borderIsThemeColor = false
    this.borderRadius = [0, 0, 0, 0],
    this.boxShadowColor = "rgba(96,100,106,1)"
    this.boxShadowH = 0
    this.boxShadowV = 0
    this.boxShadowBlur = 0
    this.boxShadowSpread = 0
    this.bgColor = "rgba(255, 255, 255, 0)"
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.color = "rgba(255,255,255,1)"
    this.textIsThemeColor = false
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.rowColMargin = 10
    this.rowColMarginRight = 10
    this.showRowColLayout = true
    this.overFlowType = "visible"
    this.animateSets = {}
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
